import { render, staticRenderFns } from "./ButtonOrders.vue?vue&type=template&id=74dd4923&"
import script from "./ButtonOrders.vue?vue&type=script&lang=js&"
export * from "./ButtonOrders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports